module.exports = __webpack_public_path__ + "static/about-807c15393ddca81c08c13975d5afa5db.jpeg";